import React, {useEffect, useState} from "react";
import Panel from "../unfox-design/Panel";
import Header from "../unfox-design/Header";
import Button from "../unfox-design/Button";
import Title from "../unfox-design/Title";
import Group from "../unfox-design/Group";
import "@vkontakte/vkui/src/components/Checkbox/Checkbox.css";
import Input from "../unfox-design/Input";
import API from '../../API'
import Snackbar from "../unfox-design/Snackbar";
import {TITLE} from "../../config";
import View from "../unfox-design/View";
class Profile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userInfo: {},
            password: '',
            newPass: '',
            snackbar: false,
            snackText: '',


            // isAdmin: false,
            // adminUserLogin: '',
            // adminUserPassword:''
        }
    }

    componentDidMount() {

        this.props.showLoaderFull(true);
        API.execute('GetUserInfo').then(data => {
            this.setState({userInfo: data.response});
            localStorage.userInfo = JSON.stringify(data.response);
            this.props.updateHwid(data.response.hwid);
            this.props.showLoaderFull(false);
        }).catch(error => {
            localStorage.clear();
            this.props.showLoaderFull();
            this.props.go('auth');
        });
        // API.execute('checkAdminRights', {accessToken: localStorage.accessToken}).then(data => {
        //     this.setState({isAdmin: true})
        // }).catch(error => {
        //     console.log(error)
        // })
    }

    // createInvite = () => {
    //     API.execute('createInviteCode', {}).then(data => {
    //         this.showSnack(true, `😁 ${data.response}`);
    //         this.componentDidMount();
    //     }).catch(error => {
    //         const errorMessage = error.error ? error.error['error_message'] : error;
    //         this.showSnack(true, `🤔 ${errorMessage}`);
    //     });
    // }

    editPass = () => {
        this.props.showLoaderFull(true);
        this.props.showModal(false);
        API.execute('changePass', {password: this.state.password, newPass: this.state.newPass}).then(data => {
            this.showSnack(true, `😁 ${data.response}`);
            localStorage.clear();
            this.props.go('auth');
        }).catch(error => {
            const errorMessage = error.error ? error.error['error_message'] : error;
            this.showSnack(true, `🤔 ${errorMessage}`);
        });
    };

    showSnack = (e, text) => {
        this.setState({snackText: text});
        this.setState({snackbar: e});
    }

    openPremiumPay = () => {
        //this.props.showLoaderFull(true);
        // API.execute('createPayment', {email: this.state.userInfo.email}).then(data => {
        //     this.props.showLoaderFull();
        //     window.open(data.response)
        // })
        window.open("https://vk.com/zenware")
    }

    logout = () => {
        API.execute('logout', {accessToken: localStorage.accessToken, email: this.state.email});
        localStorage.clear();
        this.props.go('auth');
    }

    render() {
        return (
            <Panel>
                <Header status={TITLE}
                        // after={this.state.userInfo.status && this.state.userInfo.status === 'default' ?
                        //     <Button onClick={() => this.openPremiumPay()} style={{margin: "0"}} size="m">
                        //         Купить Premium
                        //     </Button> : false}
                >
                    Profile
                </Header>
                {/*<Group>*/}
                {/*    <div style={{display: "flex", alignItems: "center"}}>*/}
                {/*        <div>*/}
                {/*            <Title>*/}
                {/*                Статус подписки:*/}
                {/*            </Title>*/}
                {/*            {this.state.userInfo.status && this.state.userInfo.status === 'default' ? 'Обычный' : 'Премиум'}*/}
                {/*        </div>*/}
                {/*        <div style={{marginLeft: "auto"}}>*/}

                {/*        </div>*/}
                {/*    </div>*/}
                {/*</Group>*/}
                {/*{this.state.userInfo.status !== 'default' &&*/}
                {/*    <Group>*/}
                {/*        <div>*/}
                {/*            <Title>*/}
                {/*                Приглашения:*/}
                {/*            </Title>*/}
                {/*            Количество: {this.state.userInfo.inviteCodes}*/}
                {/*        </div>*/}
                {/*        <div style={{display: 'flex'}}>*/}
                {/*            <Button onClick={() => {*/}
                {/*                if (this.state.userInfo.activeInviteCode && this.state.userInfo.activeInviteCode.length > 0) {*/}
                {/*                    this.showSnack(true, '😒 Код уже создан.')*/}
                {/*                    return;*/}
                {/*                }*/}
                {/*                if (parseInt(this.state.userInfo.inviteCodes) === 0) {*/}
                {/*                    this.showSnack(true, '😭 Попыток для создания кода: 0')*/}
                {/*                    return;*/}
                {/*                }*/}
                {/*                this.createInvite();*/}
                {/*            }}>*/}
                {/*                Создать приглашение*/}
                {/*            </Button>*/}
                {/*            <div style={{padding: 5}}>*/}
                {/*                <div style={{*/}
                {/*                    fontSize: '20px',*/}
                {/*                    padding: '12px 0px 6px',*/}
                {/*                }}>{this.state.userInfo.activeInviteCode ? this.state.userInfo.activeInviteCode : ''}</div>*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </Group>*/}
                {/*}*/}
                <Group>
                    <Title>
                        Your Account:
                    </Title>
                    UUID: {this.state.userInfo.id}
                    <div style={{display: 'flex'}}>
                        <Button onClick={() => {
                            this.props.showModal(true, "Change Password",
                                <div>
                                    <Input placeholder="Old password" type={'password'}
                                           onChange={(e) => this.setState({password: (e.target.value.trim())})}/>
                                    <Input placeholder="New password" type={'password'}
                                           onChange={(e) => this.setState({newPass: (e.target.value.trim())})}/>
                                    <Button onClick={() => this.editPass()}>
                                        Change Password
                                    </Button>
                                </div>);
                        }} >
                            Change Password
                        </Button>
                        <Button style={{background: 'var(--destructive)', marginLeft: '12px'}}
                                onClick={() => this.logout()}>
                            Log out!
                        </Button>
                    </div>
                </Group>
                <Snackbar start={this.state.snackbar} callback={() => {
                    this.setState({snackbar: false})
                }} vertical="bottom" duration={3000}>
                    {this.state.snackText}
                </Snackbar>
                {/*{*/}
                {/*    this.state.isAdmin ?*/}

                {/*        <Group>*/}
                {/*            <Title>Admin:</Title>*/}
                {/*            /!*<CardGrid>*!/*/}
                {/*            /!*    <Group hideSeparator={true}>*!/*/}
                {/*            /!*        <Title>test</Title>*!/*/}
                {/*            /!*        <Input placeholder="Login"/>*!/*/}
                {/*            /!*        <Input placeholder="HWID" onChange={(e) => console.log(e.target.value)}/>*!/*/}
                {/*            /!*        <Button size={"xl"}>test</Button>*!/*/}
                {/*            /!*    </Group>*!/*/}
                {/*            /!*    <Group hideSeparator={true}>*!/*/}
                {/*            /!*        <Title>test</Title>*!/*/}
                {/*            /!*        <Input placeholder="Login"/>*!/*/}
                {/*            /!*        <Input placeholder="Password" type="password"/>*!/*/}
                {/*            /!*        <Button size={"xl"}>test</Button>*!/*/}
                {/*            /!*    </Group>*!/*/}
                {/*            /!*</CardGrid>*!/*/}
                {/*            <Button onClick={() => {*/}
                {/*                this.props.showModal(true, "Смена пароля",*/}
                {/*                    <div>*/}
                {/*                        <Input placeholder="Логин" type={'text'}*/}
                {/*                               onChange={(e) => {*/}
                {/*                                   this.setState({adminUserLogin: e.target.value.trim()});*/}
                {/*                               }}/>*/}
                {/*                        <Input placeholder="Новый пароль" type={'password'}*/}
                {/*                               onChange={(e) => {*/}
                {/*                                   this.setState({adminUserPassword: e.target.value.trim()});*/}
                {/*                               }}/>*/}
                {/*                        <Button onClick={() => {*/}
                {/*                            this.props.showModal(false);*/}
                {/*                            API.execute('adminChangePassword', {accessToken: localStorage.accessToken, password: this.state.adminUserPassword, login: this.state.adminUserLogin}).then(data => {*/}

                {/*                                this.showSnack(true, `😁 ${data.response}`);*/}
                {/*                            }).catch(err => {*/}
                {/*                                const errorMessage = err.error ? err.error['error_message'] : err;*/}
                {/*                                this.showSnack(true, `🤔 ${errorMessage}`);*/}
                {/*                                console.log(err)*/}
                {/*                            });*/}
                {/*                        }}>*/}
                {/*                            Сменить*/}
                {/*                        </Button>*/}
                {/*                    </div>);*/}
                {/*            }}>*/}
                {/*                Смена Пароля*/}
                {/*            </Button>*/}
                {/*        </Group>*/}
                {/*        : <div/>*/}
                {/*}*/}
            </Panel>
        );
    }
};

export default Profile;
